// Pagos del Mes: pegarle a cada fila ligera el cuerpo de la poliza que el CRM
// ya tiene en memoria.
//
// ── POR QUE ────────────────────────────────────────────────────────────────
//
// Medido en produccion el 2026-09-02, agencia de 201 polizas: 0,9 s en total,
// de los que 266 ms son la consulta de polizas y 259 ms el viaje por la red.
// Los dos crecen en linea recta con el numero de filas, asi que una agencia de
// 1.000 polizas se va a ~4 s y una de 2.000 a ~8 s. (Lissette, queja 39: "en
// modulo de pagos del mes la carga va lenta" — y la agencia lenta pasa de
// 1.000.)
//
// Lo que viajaba era una poliza ENTERA por fila: 53 columnas, siete de ellas
// JSON y dos de texto largo. Las mismas polizas que el CRM ya se trajo al
// entrar, en segundo plano. Pagos del Mes se las bajaba otra vez.
//
// ── EL REPARTO DE RESPONSABILIDADES, QUE ES LO QUE HACE ESTO SEGURO ────────
//
// El SERVIDOR sigue decidiendo QUE filas salen: la agencia, activas +
// canceladas, las fichas borradas y el alcance del agente se aplican alli, y
// la lista de ids que llega es la buena. De memoria sale solo el CUERPO de
// cada fila, nunca la lista. Asi que esto no puede enseñar una poliza que no
// tocaba ni saltarse un permiso: solo rellena.

/**
 * @param {Array} filas las filas ligeras del servidor: { id, clientId,
 *   cancelled, customData, payment, payByPeriod? }.
 * @param {Map} porId las polizas de memoria, indexadas por id.
 * @returns {Array|null} las filas completas, o `null` si falta el cuerpo de
 *   alguna.
 *
 * DEVUELVE null SI FALTA UNA SOLA, y eso no es exceso de celo: los totales del
 * mes —dinero cobrado y pendiente— se calculan sobre las filas. Media tabla no
 * se ve como media tabla: se ve como una cifra de dinero MENOR, sin ningun
 * aviso. Quien llama vuelve a pedir la carga completa, que es un viaje de mas y
 * ya esta.
 */
export function pegarCuerposDePagos(filas, porId) {
  const lista = Array.isArray(filas) ? filas : [];
  const mapa = porId instanceof Map ? porId : new Map();
  const salida = [];
  for (const f of lista) {
    if (!f || f.id == null) return null;
    const cuerpo = mapa.get(f.id);
    if (!cuerpo) return null;
    salida.push({
      ...cuerpo,
      // El estatus CRUDO manda sobre lo que trajera la copia de memoria: es lo
      // que pinta la insignia "Cancelada" y lo que deja la fila fuera de los
      // totales de dinero.
      cancelled: f.cancelled,
      // Las columnas propias vienen del SERVIDOR aunque esten en memoria: las
      // fotos se firman alli con un permiso de lectura de corta vida, y la
      // copia de memoria las trae sin firmar — se verian rotas.
      customData: f.customData,
      payment: f.payment,
      ...(f.payByPeriod ? { payByPeriod: f.payByPeriod } : {}),
    });
  }
  return salida;
}
